'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _Symbol$for;
function _classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
        throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
    return "__private_" + id++ + "_" + name;
}
var fetchWithNetworkError = require("@uppy/utils/lib/fetchWithNetworkError");
var ErrorWithCause = require("@uppy/utils/lib/ErrorWithCause");
var AuthError = require("./AuthError.js");
var packageJson = {
    "version": "2.2.2"
}; // Remove the trailing slash so we can always safely append /xyz.
function stripSlash(url) {
    return url.replace(/\/$/, '');
}
function handleJSONResponse(res) {
    return _handleJSONResponse.apply(this, arguments);
}
function _handleJSONResponse() {
    _handleJSONResponse = _async_to_generator(function(res) {
        var jsonPromise, errMsg, errData;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (res.status === 401) {
                        throw new AuthError();
                    }
                    jsonPromise = res.json();
                    if (!(res.status < 200 || res.status > 300)) return [
                        3,
                        4
                    ];
                    errMsg = "Failed request with status: ".concat(res.status, ". ").concat(res.statusText);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        jsonPromise
                    ];
                case 2:
                    errData = _state.sent();
                    errMsg = errData.message ? "".concat(errMsg, " message: ").concat(errData.message) : errMsg;
                    errMsg = errData.requestId ? "".concat(errMsg, " request-Id: ").concat(errData.requestId) : errMsg;
                    return [
                        3,
                        4
                    ];
                case 3:
                    // eslint-disable-next-line no-unsafe-finally
                    throw new Error(errMsg);
                case 4:
                    return [
                        2,
                        jsonPromise
                    ];
            }
        });
    });
    return _handleJSONResponse.apply(this, arguments);
}
var _companionHeaders = /*#__PURE__*/ _classPrivateFieldLooseKey("companionHeaders");
var _getPostResponseFunc = /*#__PURE__*/ _classPrivateFieldLooseKey("getPostResponseFunc");
var _getUrl = /*#__PURE__*/ _classPrivateFieldLooseKey("getUrl");
var _errorHandler = /*#__PURE__*/ _classPrivateFieldLooseKey("errorHandler");
_Symbol$for = Symbol.for('uppy test: getCompanionHeaders');
var RequestClient = /*#__PURE__*/ function() {
    function RequestClient(uppy, opts) {
        var _this = this;
        _class_call_check(this, RequestClient);
        Object.defineProperty(this, _errorHandler, {
            value: _errorHandler2
        });
        Object.defineProperty(this, _getUrl, {
            value: _getUrl2
        });
        Object.defineProperty(this, _companionHeaders, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _getPostResponseFunc, {
            writable: true,
            value: function(skip) {
                return function(response) {
                    return skip ? response : _this.onReceiveResponse(response);
                };
            }
        });
        this.uppy = uppy;
        this.opts = opts;
        this.onReceiveResponse = this.onReceiveResponse.bind(this);
        this.allowedHeaders = [
            'accept',
            'content-type',
            'uppy-auth-token'
        ];
        this.preflightDone = false;
        _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
    }
    _create_class(RequestClient, [
        {
            key: "setCompanionHeaders",
            value: function setCompanionHeaders(headers) {
                _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders] = headers;
            }
        },
        {
            key: _Symbol$for,
            value: function value() {
                return _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders];
            }
        },
        {
            key: "hostname",
            get: function get() {
                var companion = this.uppy.getState().companion;
                var host = this.opts.companionUrl;
                return stripSlash(companion && companion[host] ? companion[host] : host);
            }
        },
        {
            key: "headers",
            value: function headers() {
                return Promise.resolve(_object_spread({}, RequestClient.defaultHeaders, _classPrivateFieldLooseBase(this, _companionHeaders)[_companionHeaders]));
            }
        },
        {
            key: "onReceiveResponse",
            value: function onReceiveResponse(response) {
                var state = this.uppy.getState();
                var companion = state.companion || {};
                var host = this.opts.companionUrl;
                var headers = response.headers; // Store the self-identified domain name for the Companion instance we just hit.
                if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
                    this.uppy.setState({
                        companion: _object_spread_props(_object_spread({}, companion), _define_property({}, host, headers.get('i-am')))
                    });
                }
                return response;
            }
        },
        {
            key: "preflight",
            value: function preflight(path) {
                var _this = this;
                if (this.preflightDone) {
                    return Promise.resolve(this.allowedHeaders.slice());
                }
                return fetch(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
                    method: 'OPTIONS'
                }).then(function(response) {
                    if (response.headers.has('access-control-allow-headers')) {
                        _this.allowedHeaders = response.headers.get('access-control-allow-headers').split(',').map(function(headerName) {
                            return headerName.trim().toLowerCase();
                        });
                    }
                    _this.preflightDone = true;
                    return _this.allowedHeaders.slice();
                }).catch(function(err) {
                    _this.uppy.log("[CompanionClient] unable to make preflight request ".concat(err), 'warning');
                    _this.preflightDone = true;
                    return _this.allowedHeaders.slice();
                });
            }
        },
        {
            key: "preflightAndHeaders",
            value: function preflightAndHeaders(path) {
                var _this = this;
                return Promise.all([
                    this.preflight(path),
                    this.headers()
                ]).then(function(_ref) {
                    var _$_ref = _sliced_to_array(_ref, 2), allowedHeaders = _$_ref[0], headers = _$_ref[1];
                    // filter to keep only allowed Headers
                    Object.keys(headers).forEach(function(header) {
                        if (!allowedHeaders.includes(header.toLowerCase())) {
                            _this.uppy.log("[CompanionClient] excluding disallowed header ".concat(header));
                            delete headers[header]; // eslint-disable-line no-param-reassign
                        }
                    });
                    return headers;
                });
            }
        },
        {
            key: "get",
            value: function get(path, skipPostResponse) {
                var _this = this;
                var method = 'get';
                return this.preflightAndHeaders(path).then(function(headers) {
                    return fetchWithNetworkError(_classPrivateFieldLooseBase(_this, _getUrl)[_getUrl](path), {
                        method: method,
                        headers: headers,
                        credentials: _this.opts.companionCookiesRule || 'same-origin'
                    });
                }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
            }
        },
        {
            key: "post",
            value: function post(path, data, skipPostResponse) {
                var _this = this;
                var method = 'post';
                return this.preflightAndHeaders(path).then(function(headers) {
                    return fetchWithNetworkError(_classPrivateFieldLooseBase(_this, _getUrl)[_getUrl](path), {
                        method: method,
                        headers: headers,
                        credentials: _this.opts.companionCookiesRule || 'same-origin',
                        body: JSON.stringify(data)
                    });
                }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
            }
        },
        {
            key: "delete",
            value: function _delete(path, data, skipPostResponse) {
                var _this = this;
                var method = 'delete';
                return this.preflightAndHeaders(path).then(function(headers) {
                    return fetchWithNetworkError("".concat(_this.hostname, "/").concat(path), {
                        method: method,
                        headers: headers,
                        credentials: _this.opts.companionCookiesRule || 'same-origin',
                        body: data ? JSON.stringify(data) : null
                    });
                }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
            }
        }
    ]);
    return RequestClient;
}();
function _getUrl2(url) {
    if (/^(https?:|)\/\//.test(url)) {
        return url;
    }
    return "".concat(this.hostname, "/").concat(url);
}
function _errorHandler2(method, path) {
    var _this = this;
    return function(err) {
        var _err;
        if (!((_err = err) != null && _err.isAuthError)) {
            // eslint-disable-next-line no-param-reassign
            err = new ErrorWithCause("Could not ".concat(method, " ").concat(_classPrivateFieldLooseBase(_this, _getUrl)[_getUrl](path)), {
                cause: err
            });
        }
        return Promise.reject(err);
    };
}
RequestClient.VERSION = packageJson.version;
RequestClient.defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Uppy-Versions': "@uppy/companion-client=".concat(RequestClient.VERSION)
};
module.exports = RequestClient;
